import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  TemplateRef,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {EvsProductService} from '../../../../../common/services/EvsProduct.service';
import {Router} from '@angular/router';
import {BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmationService} from 'primeng/primeng';
import {ToastrService} from 'ngx-toastr';
import {UploadService} from '../../../../../common/services/Upload.service';
import _ from 'lodash';
import {AgencyService} from '../../../qrcode/agencyListing/services/agency.service';

declare var $: any;
var that: any;

@Component({
  moduleId: module.id,
  selector: 'add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./point_of_sale.css'],
  providers: [ConfirmationService, EvsProductService],
})
@Injectable()
export class AddProductComponent implements OnInit {
  modalRef: BsModalRef;
  @Input('listIdStore') listIdStore: any;
  @Input('idDetail') idDetail: any;
  @Input('type') type: any;
  no_product = 'assets/images/no_product.png';
  @Output('backToList') backToList = new EventEmitter();
  @ViewChild('actionAgency') actionAgency: ModalDirective;
  @Output() loadEvent = new EventEmitter<string>();
  total_stamp = 0;
  pageIndexStamp = 1;
  pageSizeStamp = 5;
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];
  queryStamp = {} as any;
  formStamp = this.fb.group({
    code: null,
  });

  public FormCreateBatch: FormGroup;
  option_product: string = '';


  constructor(
    public productService: EvsProductService,
    private fb: FormBuilder,
    public router: Router,
    private toastr: ToastrService,
    public upload: UploadService,
  ) {
    that = this;
  }

  data_stamp = [];

  ngOnInit() {
    console.log("idđá",this.idDetail);

    this.fetch();
    this.FormCreateBatch = this.fb.group({
      option_product: ['same_product'],

    });
    this.FormCreateBatch.valueChanges.subscribe(val => {
      this.option_product = val.option_product
    });
  }

  closeModal() {
    this.actionAgency.hide();
  }

  showModal(): void {
    this.actionAgency.show();
    this.list_id = [];
    this.listOfChecked = [];
    this.data_stamp = [];
    this.queryStamp = {};
    this.total_stamp = 0;
    this.pageIndexStamp = 1;
    this.pageSizeStamp = 5;
    this.FormCreateBatch.controls.option_product.setValue('same_product');
    this.formStamp.reset();
    this.fetch();

  }

  prePageStamp() {
    this.pageIndexStamp = this.pageIndexStamp - 1;
    this.fetch();
  }

  inputPageStamp(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStamp) {
      this.pageIndexStamp = page;
      this.fetch();
    }
  }

  lastPageStamp() {
    console.log(this.pageIndexStamp, this.pageSizeStamp, this.total_stamp)
    if (this.pageIndexStamp * this.pageSizeStamp < this.total_stamp) {
      this.pageIndexStamp = this.pageIndexStamp + 1;
      this.fetch();
    }
  }

  checkALl(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_stamp.map((item) => {
        this.listOfChecked[item.id] = true;
      });
      this.listIdChecked();
      return;
    }
    this.data_stamp.map((item) => {
      this.listOfChecked[item.id] = false;
      this.listIdChecked();
    });
  }

  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
    console.log('this.list_id', this.list_id)
  }

  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;
    this.listOfChecked[value] = checked;
    this.isCheckAll = this.data_stamp.every(
      (item) => this.listOfChecked[item.id]
    );

    this.listIdChecked();
  }

  refeshCheckAll() {
    if (this.data_stamp && this.data_stamp.length) {
      this.isCheckAll = this.data_stamp.every(
        (item) => this.listOfChecked[item.id]
      );
      return;
    }
    this.isCheckAll = false;
  }

  fetch() {
    this.queryStamp.offset = (this.pageIndexStamp - 1) * this.pageSizeStamp;
    this.queryStamp.limit = this.pageSizeStamp;
    this.queryStamp.status = 1;
    if (!this.queryStamp.name) {
      delete this.queryStamp.name;
    }
    this.queryStamp.sort_by = 'created_time:desc';
    this.productService
      .getAllProduct(this.queryStamp)
      .subscribe(
        (res) => {
          if (res.status == 200 && !res.error) {
            this.data_stamp = res.data.products;
            console.log('this.data_stamp', this.data_stamp)
            console.log('res.data.products', res.data.products)
            this.total_stamp = res.data.count.count;
            this.refeshCheckAll();
            // this.loading_stamp = false;
            return;
          }
          this.data_stamp = [];
          this.total_stamp = 0;
          // this.loading_stamp = false;
        },
        (error) => {
          this.data_stamp = [];
          this.total_stamp = 0;
          // this.loading_stamp = false;
        }
      );
  }

  searchStamp() {
    this.pageIndexStamp = 1;
    this.queryStamp.name = this.formStamp.value.code.trim();
    this.fetch();
  }

  resetStamp() {
    this.formStamp.reset();
    this.pageIndexStamp = 1;
    this.queryStamp.name = '';

    this.fetch();
  }


  addProduct() {
    // assignType  => 0: áp dụng toàn bộ sp, 1: sp cùng áp dụng, 2: áp dụng sp hiện tại

    let body = {}

    if (this.type == 'product') {
      if (this.option_product === 'all_product') {
        body = {
          storeIds: this.listIdStore.map((i) => Number(i)),
          productIds: [0],
          assignType: 0
        }
      }
      if (this.option_product === 'same_product') {
        if (this.list_id.length == 0) {
          this.toastr.error('Bạn chưa chọn sản phẩm', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return
        }
        body = {
          storeIds: this.listIdStore.map((i) => Number(i)),
          productIds: this.list_id.map((i) => Number(i)),
          assignType: 1
        }
      }
      if (this.option_product === 'now_product') {
        body = {
          storeIds: this.listIdStore.map((i) => Number(i)),
          productIds: [this.idDetail],
          assignType: 2
        }
      }
    }
    if (this.type == 'store') {
      if (this.list_id.length == 0) {
        this.toastr.error('Bạn chưa chọn sản phẩm', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return
      }
      body = {
        storeIds: this.listIdStore.map((i) => Number(i)),
        productIds: this.list_id.map((i) => Number(i)),
        assignType: 2
      }
    }
    this.productService
      .postProductStore(body)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.toastr.success('Thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.closeModal()
            // @ts-ignore
            this.loadEvent.emit(true)
            return;
          }
          this.toastr.error(res.message, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.closeModal()
        },
        (error) => {
          this.toastr.error('Đã có lỗi xảy ra', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.closeModal()

        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product-setting/add-product.component.ts